import React, { useContext, useEffect, useState } from 'react';
import AnnonceContext from 'src/contexts/AnnonceContext';
import { getStockages } from 'src/service/stockageApi';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { InboxStackIcon } from '@heroicons/react/24/outline';

export default function BoxSelector() {
  const { formAnnonce, setFormAnnonce, currentCategory } = useContext(AnnonceContext);
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const selectedBoxId = formAnnonce.stockage ? parseInt(formAnnonce.stockage.split('/').pop()) : null;
  const selectedBox = options.find(box => box.id === selectedBoxId);
  
  useEffect(() => {
    getStockages("?motherBox=1").then((res) => {
      setOptions(res);
    });
  }, []);
 
  // Filtrage logique selon la catégorie
  let filteredOptions = options;
  let debugPrefix = '';
  if (currentCategory && currentCategory.name) {
    const prefix = currentCategory.name.substring(0, 3).toUpperCase();
    debugPrefix = prefix;
    const matching = options.filter(box => box.boxName.toUpperCase().startsWith(prefix));
    matching.sort((a, b) => (a.annonces?.length || 0) - (b.annonces?.length || 0));
    const nonMatching = options.filter(box => !box.boxName.toUpperCase().startsWith(prefix));
    filteredOptions = [...matching, ...nonMatching];
  }
  // Filtre par autocomplétion
  if (search) {
    filteredOptions = filteredOptions.filter(box => box.boxName.toLowerCase().includes(search.toLowerCase()));
  }
 
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Boite</label>
      {/* Affichage de la boîte sélectionnée ou bouton de sélection */}
      {selectedBox ? (
        <div
          className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50"
          onClick={() => setOpen(true)}
        >
          <InboxStackIcon className="w-8 h-8 text-[#1b9faa]" />
          <span className="font-semibold text-gray-800">{selectedBox.boxName}</span>
          <span className="ml-2 text-xs bg-[#1b9faa] text-white rounded-full px-2 py-1">{selectedBox.annonces ? selectedBox.annonces.length : 0} objets</span>
        </div>
      ) : (
        <button
          type="button"
          className="px-4 py-2 bg-[#1b9faa] text-white rounded-md hover:bg-[#15808a] transition-colors"
          onClick={() => setOpen(true)}
        >
          Sélectionner une boîte
        </button>
      )}
      {/* Boîte de dialogue de sélection */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Choisir une boîte</DialogTitle>
        <DialogContent>
          {/* Debug : préfixe utilisé */}
          {/* <div className="mb-2 text-xs text-gray-400">Préfixe utilisé : {debugPrefix}</div> */}
          <input
            type="text"
            placeholder="Rechercher une boîte..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full mb-4 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1b9faa]"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2">
            {filteredOptions.map((box) => (
              <div
                key={box.id}
                className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-100 transition-all ${selectedBoxId === box.id ? 'ring-2 ring-[#1b9faa]' : ''}`}
                onClick={() => {
                  setFormAnnonce({ ...formAnnonce, stockage: `api/stockages/${box.id}` });
                  setOpen(false);
                }}
              >
                <InboxStackIcon className="w-8 h-8 text-[#1b9faa]" />
                <span className="font-semibold text-gray-800">{box.boxName}</span>
                <span className="ml-2 text-xs bg-[#1b9faa] text-white rounded-full px-2 py-1">{box.annonces ? box.annonces.length : 0} objets</span>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
